import { IconExternalLink } from '@tabler/icons-react';
import React from 'react';
import { Anchor, Button, Group, Modal, Text, Title } from '@mantine/core';

const SubscriptionConfirmationUrlModal = ({ confirmationUrl, setConfirmationUrl }) => {
  return (
    <Modal size="lg" opened={!!confirmationUrl} onClose={() => setConfirmationUrl(undefined)} title="Please click on the button below to confirm your subscription changes.">
      <div style={{ textAlign: 'center' }}>
        <Title order={3}>
          {' '}
          <Anchor href={confirmationUrl}>
            <IconExternalLink size={20} /> Confirm Subscription Changes
          </Anchor>
        </Title>

        <Text size="lg" c="dimmed" mt="md">
          Note: You will be redirected to your account vendor and may need to log in. If you do not have sufficient
          permissions to perform this action, you can copy the link above and share it with a colleague who does!
        </Text>
      </div>
      <Group justify="flex-end" mt="md">
        <Button variant="default" fullWidth onClick={() => setConfirmationUrl(undefined)}>
          Cancel
        </Button>
      </Group>
    </Modal>
  );
};

export default SubscriptionConfirmationUrlModal;
